import { FileDown } from "lucide-react";
import {
  COMPANY_DECK_LABEL,
  COMPANY_DECK_URL,
  COMPANY_DECK_FILENAME,
} from "../../constants/company-deck";

export default function CompanyDeckButtonFooter({ className = "" }) {
  return (
    <a
      href={COMPANY_DECK_URL}
      download={COMPANY_DECK_FILENAME}
      className={`inline-flex items-center justify-center gap-2 rounded-full bg-navy text-white border border-teal/30 hover:bg-[#162d4a] font-medium transition-colors text-center px-4 sm:px-5 py-2.5 text-sm w-full sm:w-auto shadow-sm shadow-black/10 ${className}`}
    >
      <FileDown className="w-5 h-5 shrink-0 text-teal" aria-hidden />
      <span className="leading-snug">{COMPANY_DECK_LABEL}</span>
    </a>
  );
}
